const biroCards = document.querySelectorAll( '.card-content' );

biroCards.forEach( function( card ) {

  card.addEventListener( 'click', function( event ) {

    window.location.href = event.target.closest( '.card-content' ).querySelector( '.link' ).getAttribute( 'href' );

  } );

} );
